import {
  SearchableSelect,
  SelectItem,
  type SearchableSelectProps,
} from '@sapphire-react/core';
import { ReactNode } from 'react';
import { Controller } from 'react-hook-form';
import { useSapphireMedia } from '../hooks';
import { FormFieldProps } from '../types';
import { applyDataTestIdToChildren } from '../utils';

type Props = Omit<SearchableSelectProps<any>, 'name'> & {
  name: string;
  children: ReactNode;
} & FormFieldProps;

export function SearchableSelectField(props: Props) {
  const { control, name, defaultValue, children, rules, ...rest } = props;
  const { isExtraSmall, isSmall } = useSapphireMedia();

  // FIXME: unable to pass ...rest because of "Expression produces a union type that is too complex to represent" error
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue || undefined}
      render={({ field: { ref: _ref, ...field }, fieldState: { error } }) => (
        <SearchableSelect
          {...field}
          placeholder={rest.placeholder}
          label={rest.label}
          width={'100%'}
          id={field.name}
          value={field.value}
          error={error?.message}
          onChange={(selectedValue) => field.onChange(selectedValue)}
          size={isExtraSmall || isSmall ? 'md' : 'lg'}
          data-test-id={`${name}-select`}
          prefix={rest.prefix}
        >
          {applyDataTestIdToChildren(
            children,
            SelectItem,
            name,
            'Option',
            'children',
          )}
        </SearchableSelect>
      )}
    />
  );
}
